<template>
  <PmNotificationContainerPure
    notification-type="error"
    :date="date"
    :is-unread="isUnread"
    title="Fehler beim Laden der Benachrichtigung"
    @mark-as-read="emit('markAsRead')"
    @mark-as-unread="emit('markAsUnread')"
  >
    <template #meta>
      <PmMetaListItemPure label="ID" variant="error">
        {{ notificationId }}
      </PmMetaListItemPure>

      <PmMetaListItemPure label="Typ" variant="error">
        {{ notificationType }}
      </PmMetaListItemPure>

      <PmMetaListItemPure v-if="errorMessage" label="Fehler" variant="error">
        {{ errorMessage }}
      </PmMetaListItemPure>
    </template>
  </PmNotificationContainerPure>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const COMPONENT_NAME = 'PmNotificationErrorPure'

export default defineComponent({
  name: COMPONENT_NAME,
})
</script>

<script setup lang="ts">
import PmNotificationContainerPure, {
  type Props as PropsNotificationContainerPure,
} from '@/components/PmNotification/PmNotificationContainerPure.vue'
import PmMetaListItemPure from '@/components/PmMetaList/PmMetaListItemPure.vue'

export interface Props
  extends Pick<PropsNotificationContainerPure, 'date' | 'isUnread'> {
  notificationId: number
  notificationType: string
  errorMessage?: string
}

const props = withDefaults(defineProps<Props>(), {})

const emit = defineEmits<{
  markAsRead: []
  markAsUnread: []
}>()
</script>
